import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export const getDeals = () => jsData.Deal.findAll();

export const getDealsV2 = (cid, aid) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Deals.get({
    IsUseV2: true,
  }).toPromise();
